export default [
    {
      title: 'Landing',
      icon: 'HomeIcon',
      tagVariant: 'light-warning',
      route: 'landing'
    },
  ]
  